/**
 * @generated SignedSource<<814f4527dd431ad3c1066c7f1e04ab1f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type JobEstimateSourceEnum = "SYSTEM" | "USER";
export type JobStatusEnum = "CANCELLED" | "COMPLETED" | "RUNNING" | "SCHEDULED";
import { FragmentRefs } from "relay-runtime";
export type TimerContentLeftDetailsFragment$data = {
  readonly actualStopTime: any | null | undefined;
  readonly durations: {
    readonly dynamicDurationMinutes: number | null | undefined;
  } | null | undefined;
  readonly estimateSource: JobEstimateSourceEnum | null | undefined;
  readonly estimatedStopTime: any | null | undefined;
  readonly plannedStop: any | null | undefined;
  readonly status: JobStatusEnum | null | undefined;
  readonly " $fragmentType": "TimerContentLeftDetailsFragment";
};
export type TimerContentLeftDetailsFragment$key = {
  readonly " $data"?: TimerContentLeftDetailsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimerContentLeftDetailsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimerContentLeftDetailsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Durations",
      "kind": "LinkedField",
      "name": "durations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dynamicDurationMinutes",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualStopTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "estimatedStopTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedStop",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "estimateSource",
      "storageKey": null
    }
  ],
  "type": "Job",
  "abstractKey": "__isJob"
};

(node as any).hash = "381425f148220d2fa6fedd2358ca566a";

export default node;
